var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 512.002 512.002",
    id: "cart",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.59 382.711c-35.646 0-64.646 29-64.646 64.646s29 64.646 64.646 64.646 64.646-29 64.646-64.646-29.001-64.646-64.646-64.646zm0 90.504c-14.261 0-25.858-11.597-25.858-25.858 0-14.261 11.597-25.858 25.858-25.858 14.254 0 25.858 11.597 25.858 25.858 0 14.26-11.597 25.858-25.858 25.858zm191.351-90.504c-35.646 0-64.646 29-64.646 64.646s29 64.646 64.646 64.646 64.646-29 64.646-64.646-29-64.646-64.646-64.646zm0 90.504c-14.261 0-25.858-11.597-25.858-25.858 0-14.261 11.597-25.858 25.858-25.858 14.261 0 25.858 11.597 25.858 25.858 0 14.26-11.597 25.858-25.858 25.858zm112.147-346.941a19.4 19.4 0 0 0-15.179-7.324H143.326l-17.629-89.095a19.392 19.392 0 0 0-15.528-15.308L32.594.325C22.038-1.621 11.953 5.368 10.02 15.905s5.042 20.641 15.58 22.574l64.607 11.843 56.914 287.667c1.797 9.083 9.768 15.631 19.025 15.631h271.512c9.031 0 16.86-6.225 18.896-15.037l45.252-195.876a19.38 19.38 0 0 0-3.718-16.433zm-75.855 188.559H182.074l-31.075-157.089h307.519l-36.285 157.089z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.24b013a1fa5fc4a27e6e4348ef5d73c4.svg";
export { ForwardRef as ReactComponent };